import { STRINGS } from '@/constants/strings';
import { EnterEmailScreen } from '@/features/auth/screens/enter-email-screen';
import { EnterPasswordScreen } from '@/features/auth/screens/enter-password-screen';
import { ForgotPasswordScreen } from '@/features/auth/screens/forgot-password-screen';
import { VerifyEmailScreen } from '@/features/auth/screens/verify-email-screen';
import { publicScreens } from '@/navigations/public-stack';
import type { UnAuthStackParamList } from '@/navigations/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

const Stack = createNativeStackNavigator<UnAuthStackParamList>();

export function UnAuthStack() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        animation: 'slide_from_right',
        title: STRINGS.appDocumentTitle,
      }}>
      <Stack.Screen name="EnterEmail" component={EnterEmailScreen} />
      <Stack.Screen name="EnterPassword" component={EnterPasswordScreen} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} />
      <Stack.Screen name="VerifyEmail" component={VerifyEmailScreen} />
      {publicScreens.map(screen => (
        <Stack.Screen key={screen.name} name={screen.name} component={screen.component} />
      ))}
    </Stack.Navigator>
  );
}
